// `React` in scope for the classic-runtime renderchecks — see `CrossIcon`.
import React from "react";
import { Person } from "@rista/ui/library/icons/glyphs";

// The drawing is the design system's icon glyph (`@rista/ui/library/icons/glyphs`, DESIGN_SYSTEM.md QD10); this keeps
// this file's import path and the size and colour it always drew, so its callers render exactly as before.
/** A head-and-shoulders outline: the customer-profile card's header mark. */
export function PersonIcon({ color = "#000000" }: { color?: string }) {
  return <Person size={14} color={color} />;
}

PersonIcon.displayName = "PersonIcon";
export default PersonIcon;
